/** Map drivers table columns → profiles columns (Saarthi app stores docs on profiles). */
export const PROFILE_DOCUMENT_FALLBACKS = {
  aadhaar_image_url: 'government_id_url',
  aadhaar_back_image_url: 'government_id_back_url',
  license_image_url: 'license_front_url',
  license_back_image_url: 'license_back_url',
  license_selfie_url: 'license_selfie_url',
  driver_photo_url: 'avatar_url',
};

export function appProfileIdForDriver(driver) {
  if (!driver) return '';
  const linked = String(driver.app_profile_id || '').trim();
  if (linked) return linked;
  if (driver.signup_source === 'app') return String(driver.id || '').trim();
  return '';
}

export function mergeProfileDocumentFallbacks(driver, profileRow) {
  if (!driver) return driver;
  if (!profileRow) return { ...driver };

  const merged = { ...driver };
  for (const [driverCol, profileCol] of Object.entries(PROFILE_DOCUMENT_FALLBACKS)) {
    const onDriver = String(merged[driverCol] || '').trim();
    const onProfile = String(profileRow[profileCol] || '').trim();
    if (!onDriver && onProfile) {
      merged[driverCol] = onProfile;
    }
  }
  return merged;
}

export function parseStorageDocumentRef(value) {
  const raw = String(value || '').trim();
  if (!raw) return null;

  if (/^https?:\/\//i.test(raw)) {
    const publicMatch = raw.match(
      /\/storage\/v1\/object\/public\/([^/]+)\/(.+?)(?:\?|$)/i
    );
    if (publicMatch) {
      return {
        bucket: publicMatch[1],
        path: decodeURIComponent(publicMatch[2]),
      };
    }
    return { directUrl: raw };
  }

  if (raw.startsWith('storage://')) {
    const rest = raw.slice('storage://'.length).replace(/^\/+/, '');
    const slash = rest.indexOf('/');
    if (slash <= 0) return null;
    return {
      bucket: rest.slice(0, slash),
      path: rest.slice(slash + 1),
    };
  }

  return { directUrl: raw };
}

export async function resolveDocumentDisplayUrl(supabaseClient, value) {
  const raw = String(value || '').trim();
  if (!raw || !supabaseClient) return null;

  const ref = parseStorageDocumentRef(raw);
  if (!ref) return null;
  if (ref.directUrl) return ref.directUrl;

  const { data, error } = await supabaseClient.storage
    .from(ref.bucket)
    .createSignedUrl(ref.path, 60 * 60);

  if (!error && data?.signedUrl) {
    return data.signedUrl;
  }

  const { data: pub } = supabaseClient.storage.from(ref.bucket).getPublicUrl(ref.path);
  return pub?.publicUrl || raw;
}

export async function fetchProfileRowForDriverDocuments(supabaseClient, driver) {
  const profileId = appProfileIdForDriver(driver);
  if (!supabaseClient || !profileId) {
    return { profile: null, error: '' };
  }

  const columns = [...new Set(Object.values(PROFILE_DOCUMENT_FALLBACKS))].join(',');
  const { data, error } = await supabaseClient
    .from('profiles')
    .select(columns)
    .eq('id', profileId)
    .maybeSingle();

  if (error) {
    return { profile: null, error: error.message || 'Could not load app profile documents.' };
  }
  return { profile: data, error: '' };
}
